export const refreshRate = 350; //ms
export const SPEED_OPTIONS = [0.75, 1, 1.25, 1.5, 2];